export default __webpack_public_path__ + "favicon-180x180.v2.png";